import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import API_BASE from "./config";
import "./css/SraRequests.css";

// Friendly labels for the source column (new sources fall back to upper-case key).
const SOURCE_LABELS = { sra: "SRA", gdc: "GDC", "1000g": "1000 Genomes", ucsc: "UCSC", ensembl: "Ensembl", url: "Custom URLs" };
const sourceLabel = (s) => SOURCE_LABELS[s] || String(s || "").toUpperCase();

// Unified "Previous Downloads" table across every public-data source. When `source`
// is omitted the backend returns ALL sources (SRA / GDC / 1000G / UCSC / Ensembl / …).
const DownloadRequests = ({ source, title = "Previous Downloads" }) => {
  const [requests, setRequests] = useState([]);
  const location = useLocation();
  const successMessage = location.state?.message || "";

  const fetchRequests = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/public-data/jobs`, {
        params: { source },
        withCredentials: true,
      });
      setRequests(res.data.jobs || []);
    } catch (e) {
      console.error("Failed to load download requests:", e);
    }
  };

  useEffect(() => {
    fetchRequests();
    const iv = setInterval(fetchRequests, 15000);
    return () => clearInterval(iv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source]);

  const fmtGB = (b) => (Number(b || 0) / 1024 ** 3).toFixed(3);

  const statusStyle = (s) => {
    if (s === "completed") return { color: "#166534", fontWeight: 600 };
    if (s === "partial") return { color: "#b45309", fontWeight: 600 };
    if (s === "failed") return { color: "#b91c1c", fontWeight: 600 };
    return { color: "#6b7280" };
  };

  return (
    <div className="analyses-container">
      <h2>{title}</h2>

      {successMessage && <div className="sra-success-banner">{successMessage}</div>}

      <table className="job-summary-table">
        <thead>
          <tr>
            <th>Source</th>
            <th>Project Name</th>
            <th>Status</th>
            <th>Items</th>
            <th>Size (GB)</th>
            <th>Credits</th>
            <th>Submitted</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((req) => (
            <tr key={req.id}>
              <td>{sourceLabel(req.source)}</td>
              <td>{req.project_name}</td>
              <td style={statusStyle(req.status)}>
                {req.status}
                {req.status === "failed" && req.error && (
                  <div style={{ fontSize: 12, color: "#6b7280" }}>{req.error}</div>
                )}
              </td>
              <td>{(req.completed_count ?? 0)} / {req.requested_count}</td>
              <td>{fmtGB(req.total_bytes)}</td>
              <td>{req.credits_charged != null ? Math.abs(req.credits_charged) : "-"}</td>
              <td>{new Date(req.created_at).toLocaleString()}</td>
            </tr>
          ))}
          {requests.length === 0 && (
            <tr><td colSpan="7" style={{ color: "#6b7280" }}>No download requests yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DownloadRequests;
